import * as React from 'react';
import { Grid, Row, Col } from 'react-styled-flexboxgrid';
import Styled from './Logos.style';
export const Logos: React.FC = () => {
  return (
    <Grid>
      <Row style={{ margin: '32px 0' }}>
        <Col xs={12}>
          <Styled.Wrap className="partner-logos">
            {[
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/twrc_logo.png',
                alt: 'The Water Retail Company',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/logo-wave.png',
                alt: 'Wave',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/everflow.png',
                alt: 'Everflow',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/sfb.png',
                alt: 'SfB',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/pe-color.png',
                alt: 'PE',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/essex.png',
                alt: 'Essex and Suffolk',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/aws_horizontal_logo.png',
                alt: 'Anglian Water',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/castle-water.png',
                alt: 'Castle Water',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/cam-logo.png',
                alt: 'Cambridge Water',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/affinity.png',
                alt: 'Affinity Water',
              },
              {
                src: 'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/matrixgroup-color.png',
                alt: 'Matrix Group',
              },
            ].map((logo) => (
              <div className="partner-logo" key={logo.alt}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </Styled.Wrap>
        </Col>
      </Row>
    </Grid>
  );
};

export default Logos;
